let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lW4YX")).then(() => parcelRequire('cdCME'));